module.exports = __webpack_public_path__ + "static/flags/MZ-3efaaf6de04bbe64bdbe1f25dede9d9e.gif";